import { render, staticRenderFns } from "./AppBundleGroups.vue?vue&type=template&id=5c31912a&"
import script from "./AppBundleGroups.vue?vue&type=script&lang=js&"
export * from "./AppBundleGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports